import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#607D8B',
        secondary: '#009688',
        accent: '#E91E63',
      }
    }
  }
});
